<template>
  <div>
    <div class="so-combo-prices-toolbar">
      <FranchiseSelect
        v-model="franchiseId"
        elem-id="so-combo-prices-franchise"
        :label="t('Franquia')"
      />
      <app-button
        v-if="podeEscrever"
        :label="t('Adicionar preço de combo')"
        icon="pi pi-plus"
        size="small"
        :disabled="!franchiseId"
        :explanation="franchiseId ? EX.precoUnidade : EX.semFranquia"
        data-testid="so-combo-prices-add-btn"
        @click="handleNew"
      />
      <InfoTip
        v-else
        :explanation="EX.somenteLeitura"
        :label="t('Preço dos combos')"
        test-id="so-combo-prices-readonly-info"
      />
    </div>

    <s-o-combo-prices-table
      ref="tableRef"
      :franchise-id="franchiseId"
      :pode-escrever="podeEscrever"
      @edit="handleEdit"
      @delete="handleDelete"
    />

    <!-- SOComboPricesModal é centralizado no ModalManager.vue -->
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { permissionsService } from '../../services/permissionsService';
import { comboExplanations } from '../so-combos/explanations';
import SOComboPricesTable from './SOComboPricesTable.vue';
import type { ComboPrices_PriceRow } from '../../contracts/ComboPrices_PriceRow';

const { t } = useI18n();

const EX = computed(() => comboExplanations(t));
const tableRef = ref<{ loadData: () => void } | null>(null);
const franchiseId = ref<number | string | null>(null);

// Espelha GRUPOS_ESCRITA de so/combo_prices.php: Gerente lê, não grava.
const podeEscrever = computed<boolean>(() => permissionsService.isUserInGroups(['Full', 'Franqueado']));

const handleNew = (): void => {
  eventBus.emit('modal.so-combo-prices.open', { action: 'create', franchiseId: franchiseId.value });
};

const handleEdit = (entry: ComboPrices_PriceRow): void => {
  eventBus.emit('modal.so-combo-prices.open', { action: 'edit', franchiseId: franchiseId.value, entry });
};

const handleDelete = (entry: ComboPrices_PriceRow): void => {
  eventBus.emit('modal.so-combo-prices.open', { action: 'delete', franchiseId: franchiseId.value, entry });
};

const onSaved = (): void => tableRef.value?.loadData();

onMounted(() => {
  eventBus.on('so-combo-prices.saved', onSaved);
});

onBeforeUnmount(() => {
  eventBus.off('so-combo-prices.saved', onSaved);
});
</script>

<style scoped>
.so-combo-prices-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
</style>
